import React from 'react'
import { useEffect, useState, useRef } from 'react';
import { Drawer } from '@material-ui/core';
import { useDispatch, useSelector  } from "react-redux";
import TreeView from '@mui/lab/TreeView';
import TreeItem, { treeItemClasses } from '@mui/lab/TreeItem';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import Menu from '@mui/material/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@mui/material/Divider';

import { isEmpty, CellType} from '../modules/appLibrary';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';

/*----------------------------------------------------------------------
 * メインメニュ
 * show: true:open 
 * doClose : close call back
 -----------------------------------------------------------------------*/
export default function StaffGroups(props) {

    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [groups, setgroups] = useState([]);
    const [windowheight, setwindowheight] = useState(300);
    const [wapperheight, setwapperheight] = useState(300);

    const CELLTYPE = CellType();
    const targetRef = useRef();


    const StyledTreeItemRoot = styled(TreeItem)(({ theme }) => ({
        color: theme.palette.text.secondary,
        [`& .${treeItemClasses.content}`]: {
            color: theme.palette.text.secondary,
            borderTopRightRadius: theme.spacing(2),
            borderBottomRightRadius: theme.spacing(2),
            paddingRight: theme.spacing(1),
            fontWeight: theme.typography.fontWeightMedium,
            '&.Mui-expanded': {
                fontWeight: theme.typography.fontWeightRegular,
            },
            '&:hover': {
                backgroundColor: theme.palette.action.hover,
            },
            '&.Mui-focused, &.Mui-selected, &.Mui-selected.Mui-focused': {
                backgroundColor: `var(--tree-view-bg-color, ${theme.palette.action.selected})`,
                color: 'var(--tree-view-color)',
            },
            [`& .${treeItemClasses.label}`]: {
                fontWeight: 'inherit',
                color: 'inherit',
            },
        },
        [`& .${treeItemClasses.group}`]: {
            marginLeft: 0,
            [`& .${treeItemClasses.content}`]: {
                paddingLeft: theme.spacing(2),
            },
        },
    }));
    useEffect(() => {
        setOpen(props.show)
        handleResize();
        if (props.show) {
            getList();
        }
    }, [props.show])

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    function handleResize() {
        setwindowheight(window.innerHeight);
        let h = window.innerHeight - 100;
        setwapperheight(h);
    }

    function doClose() {
        props.doClose();
    }

    const [contextMenu, setContextMenu] = useState(null);
    const GroupMenuOpen = (event, group, kind, groupId, staff) => {
        if (kind === "1") {   //Group
            targetRef.current = group;
            setContextMenu(
                contextMenu === null
                    ? {
                        mouseX: event.clientX + 2,
                        mouseY: event.clientY - 6,
                    }
                    : null,
            );
        } else {    //member
            props.fnc.current.confmsg(group + "を" + groupId + "から削除しますよろしいですか？", () => Action(groupId, staff));
            function Action(group,staff) {
                const param = {
                    "key": group,
                    "code": staff
                }
                props.fnc.current.postaxios('menu/DeleteStaff', param,
                    {
                        onSuccess: function (data) {
                            setgroups(data.list);
                            props.fnc.current.success();
                            props.fnc.current.wait();
                        },
                        errmsg: "保存に失敗しました"
                    }
                )
            }
        }
    };
    function handleClose(){
        setContextMenu(null);
    };

    function getList() {
        props.fnc.current.postaxios('menu/GetGroup', null,
            {
                onSuccess: function (data) {
                    setgroups(data.list);
                },
                errmsg: "データ取得に失敗しました"
            }
        )
    }
    function GroupsClick(kind) {
        if (kind === '0') {    //新規作成
            props.fnc.current.searchlistopen({
                label: "担当者",
                multiple: true,
                rowmode: false,
                data: {datatype:CELLTYPE.MASTER, dataid:'m_staff'},
                doApply: setnewgroupstaff
            });
        }
    }
    function setnewgroupstaff(e) {
        props.fnc.current.formdialogopen({
            title: "担当者グループ作成", inputname: "グループ名", dialogtype: 0,
            placeholder: "グループ名を入力してください",
            defaultvalue: '',
            contents: "新規の担当者グループを作成します。",
            onApply: (name) => Save(name,e)
        });

        function Save(name, staffs) {
            const param = {
                "key": name,
                "code":staffs.value
            }
           props.fnc.current.postaxios('menu/SaveGroup', param,
                {
                    onSuccess: function (data) {
                        props.fnc.current.searchlistclose();
                        props.fnc.current.formdialogclose();
                        setgroups(data.list);
                        props.fnc.current.success();
                        props.fnc.current.wait();

                 },
                    errmsg: "保存に失敗しました"
                }
            )
         }
    }

    function AddStaff() {
        handleClose();
        props.fnc.current.searchlistopen({
            label: "担当者",
            multiple: true,
            rowmode: false,
            data: { datatype: CELLTYPE.MASTER, dataid: 'm_staff' },
            doApply: setaddgroupstaff
        });
        function setaddgroupstaff(staffs) {
            const param = {
                "key": targetRef.current,
                "code": staffs.value
            }
            props.fnc.current.postaxios('menu/AddGroup', param,
                {
                    onSuccess: function (data) {
                        props.fnc.current.searchlistclose();
                        setgroups(data.list);
                        props.fnc.current.success();
                        props.fnc.current.wait();

                    },
                    errmsg: "保存に失敗しました"
                }
            )
        }
    }

    function QuitGroup() {
        handleClose();
        props.fnc.current.confmsg("グループ" + targetRef.current + "から退会しますよろしいですか？", () => Action(targetRef.current));
        function Action(group) {
            const param = {
                "code": targetRef.current,
            }
            props.fnc.current.postaxios('menu/QuitGroup', param,
                {
                    onSuccess: function (data) {
                        setgroups(data.list);
                        props.fnc.current.success();
                        props.fnc.current.wait();

                    },
                    errmsg: "処理に失敗しました"
                }
            )
        }
    }
    function DeleteGroup() {
        handleClose();
        props.fnc.current.confmsg(["グループ" + targetRef.current + "を削除しますよろしいですか？","グループに所属する全担当者から削除されます。"], () => Action(targetRef.current));
        function Action(group) {
            const param = {
                "code": targetRef.current,
            }
            props.fnc.current.postaxios('menu/DeleteGroup', param,
                {
                    onSuccess: function (data) {
                        setgroups(data.list);
                        props.fnc.current.success();
                        props.fnc.current.wait();

                    },
                    errmsg: "処理に失敗しました"
                }
            )
        }
    }

    function StyledTreeItem(props) {
        const {
            bgColor,
            color,
            staff,
            groupId,
            labelInfo,
            labelInfo2,
            labelText,
            ...other
        } = props;

        return (
            <StyledTreeItemRoot
                label={
                    <Box sx={{ display: 'flex', alignItems: 'center', p: 0.5, pr: 0 }}
                        onClick={() => GroupsClick(labelInfo2)}
                    >
                        {labelInfo2 === undefined?null:(labelInfo2 === '0' ? <Icon>groupadd</Icon>:<Icon>group_work</Icon>)}
                        <Typography variant="body2" sx={{ fontWeight: 'inherit', flexGrow: 1, ml:2 }}>
                            {labelText}
                        </Typography>
                        <Typography variant="caption" color="inherit">
                            {labelInfo}
                        </Typography>
                        {labelInfo2 === '0'?null:
                            <IconButton size="small" style={{ marginLeft: 10 }} onClick={(e) => GroupMenuOpen(e, labelText, labelInfo2, groupId, staff)}>
                                {labelInfo2 === '1'?
                                    < Icon style={{ fontSize: 15 }}>menu</Icon>
                                    :
                                    < Icon style={{ fontSize: 15 }}>delete_outline</Icon>
                                }
                        </IconButton>
                        }
                    </Box>
                }
                style={{
                    '--tree-view-color': color,
                    '--tree-view-bg-color': bgColor,
                }}
                {...other}
            />
        );
    }

     return (
         <Drawer anchor={"top"} open={open} id="groupspanel">
             <div style={{ display: 'flex', backgroundColor: '#E7EBF0', height:windowheight}}>
                <div style={{ position: 'absolute', top: 0, left: 0 }}>
                <IconButton onClick={doClose} title="閉じる">
                    <Icon style={{ fontSize: 30 }}>close</Icon>
                </IconButton>
                </div> 
                <div style={{ position: 'absolute', top: 20, left: 100, color: '#999999', fontSize: 20 }}>担当者グループ設定</div>

                 <div style={{ width: 600, height: '100hv', margin: '0 auto', paddingTop: 60}}>
                    <TreeView
                        defaultCollapseIcon={<ArrowDropDownIcon />}
                        defaultExpandIcon={<ArrowRightIcon />}
                        defaultEndIcon={<div style={{ width: 24 }} />}
                    sx={{ height: wapperheight, flexGrow: 1, maxWidth: 500, overflowY: 'auto', backgroundColor: '#FEFEFE',pt:2,pr:3  }}
                    >
                         <StyledTreeItem nodeId="new" labelText="新規作成" labelInfo2="0"/>

                         {groups.map(group => {
                            return (
                                <StyledTreeItem nodeId={group.key} labelText={group.key} labelInfo={group.member.length } labelInfo2="1">
                                    {group.member.map(member => {
                                        return (
                                            <StyledTreeItem
                                                nodeId={member.code}
                                                labelText={member.name}
                                                groupId={group.key}
                                                staff={member.code}
                                           />
                                        );
                                    })}
                                </StyledTreeItem> 
                            );
                         })}
                         </TreeView>
                     </div>
             </div>

             <Menu
                 open={contextMenu !== null}
                 onClose={handleClose}
                 anchorReference="anchorPosition"
                 anchorPosition={
                     contextMenu !== null
                         ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                         : undefined
                 }
             >
                 <MenuItem onClick={AddStaff}>担当者追加</MenuItem>
                 <Divider/>
                 <MenuItem onClick={QuitGroup}>グループ退会</MenuItem>
                 <MenuItem onClick={DeleteGroup}>グループ削除</MenuItem>
             </Menu>

        </Drawer>
    )
}
